import { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import NavigationBar from "../DesktopNav";
import Header from "./TopBar";
import OrderWebSocket from "../../WebSocket/OrderWebSocket";
import OrderUpdateWebSocket from "../../WebSocket/OrderUpdateWebSocket";
import NoIndex from "../NoIndex";

const DashboardLayout = () => {
  const navigate = useNavigate();

  const userData = JSON.parse(sessionStorage.getItem("user"));
  const userID = userData?.userid;

  // UUID Generator
  const generateUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );

  // Generate sessionID after login
  useEffect(() => {
    if (!userID) return;

    let storedSessionID = sessionStorage.getItem("sessionID");

    if (!storedSessionID) {
      storedSessionID = generateUUID();
      sessionStorage.setItem("sessionID", storedSessionID);
    }
  }, [userID]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <>
      <NoIndex />

      <div className="flex h-screen w-full overflow-hidden">
        <OrderWebSocket
          userID={userID}
          onNewOrder={() =>
            window.dispatchEvent(new Event("newOrderReceived"))
          }
        />

        <OrderUpdateWebSocket userID={userID} onOrderUpdate={() => {}} />

        {/* LEFT SIDEBAR - fixed space reserve */}
        <div className="h-screen shrink-0">
          <NavigationBar handleLogout={handleLogout} userID={userID} />
        </div>

        {/* RIGHT SIDE */}
        <div className="flex min-w-0 flex-1 flex-col">
          <Header />

          {/* CONTENT */}
     <main className="min-w-0 flex-1 min-h-0 overflow-hidden bg-[#dfedff36]">
  <Outlet />
</main>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;